import { MarkdownSize, breakpointTypes, } from '@vtblife/react-markdown-types';
import { useMemo } from 'react';
export function useMarkdownBreakpointsSettings({ minimalHeadingStyleLevel: _minimalHeadingStyleLevel = 1, sizeVariant, breakpoints, footnote, colorVariant = 'white', paddingSize, }) {
    const breakpointsSettings = useMemo(() => {
        const settings = {
            renderersBreakpoints: { l: {}, m: {}, s: {}, xl: {}, xs: {} },
            classNamesBreakpoints: { l: {}, m: {}, s: {}, xl: {}, xs: {} },
        };
        if (breakpoints) {
            for (const breakpoint of breakpointTypes) {
                settings.renderersBreakpoints[breakpoint].minimalHeadingStyleLevel =
                    breakpoints[breakpoint].minimalHeadingStyleLevel || _minimalHeadingStyleLevel;
                settings.classNamesBreakpoints[breakpoint].colorVariant =
                    breakpoints[breakpoint].colorVariant || colorVariant;
                settings.classNamesBreakpoints[breakpoint].paddingSize =
                    breakpoints[breakpoint].paddingSize || paddingSize;
                settings.classNamesBreakpoints[breakpoint].sizeVariant =
                    breakpoints[breakpoint].sizeVariant || sizeVariant;
            }
            return settings;
        }
        for (const breakpoint of breakpointTypes) {
            let minimalHeadingStyleLevel = _minimalHeadingStyleLevel;
            if (sizeVariant === MarkdownSize.PersonalAreaSmall && minimalHeadingStyleLevel < 5) {
                minimalHeadingStyleLevel = 5;
            }
            else if ((sizeVariant === MarkdownSize.Small || footnote) && minimalHeadingStyleLevel < 4) {
                minimalHeadingStyleLevel = 4;
            }
            else if ((sizeVariant === MarkdownSize.Medium || sizeVariant === MarkdownSize.PersonalAreaMedium) &&
                minimalHeadingStyleLevel < 3) {
                minimalHeadingStyleLevel = 3;
            }
            settings.renderersBreakpoints[breakpoint].minimalHeadingStyleLevel = minimalHeadingStyleLevel;
            settings.classNamesBreakpoints[breakpoint].colorVariant = colorVariant;
            settings.classNamesBreakpoints[breakpoint].paddingSize = paddingSize;
            settings.classNamesBreakpoints[breakpoint].sizeVariant = sizeVariant;
        }
        return settings;
    }, [_minimalHeadingStyleLevel, breakpoints, footnote, colorVariant, paddingSize, sizeVariant]);
    return breakpointsSettings;
}
//# sourceMappingURL=use-markdown-breakpoints-settings.js.map